<template>
  <v-card
    class="mx-auto mb-7"
    width="80%"
  >
    <v-card-text>
      <div class="text-h4">Thank you!</div>
      <p>
        You've got everything done! Your order is undergoing final review,
        you should be contacted within 3 business days.</p>
      <p>
        Visit the link below to view the forms that you have filled out.
        Feel free to bookmark this link or to print the page
      </p>

      <a :href="reviewLink" target="_blank">Forms</a>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Completed',
  computed: {
    reviewLink() {
      const url = 'https://portal.123.net/agents/additional_information';
      const contractId = this.$route.params.contract_id;
      const accessKey = this.$route.params.access_key;
      return `${url}/${contractId}/${accessKey}`;
    },
  },
};
</script>
